<template>
  <div id="contenedor-obrassolicitudes-configuracion-main">
    <v-container
      fluid>
      <v-card
        flat>
        <v-card-text>
          <titulo-tool-bar
            titulo="Configuración">
          </titulo-tool-bar>
          <opciones-tool-bar></opciones-tool-bar>
        </v-card-text>
      </v-card>
    </v-container>
    <router-view></router-view>
  </div>
</template>

<script>
import TituloToolBar from '@/components/TituloToolBar.vue';
import OpcionesToolBar from './OpcionesToolBar.vue';

export default {
  name: 'ObrasSolicitudesConfiguracionMain',
  components: {
    TituloToolBar,
    OpcionesToolBar,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
